import i18n from "i18next";

i18n.init({
  lng: "en", // default language
  fallbackLng: "en",
  supportedLngs: ["en", "zh", "ja", "es", "fr", "de", "it"],
  defaultNS: "common",
  ns: ["common", "itinerary"],
  resources: {
    en: {
      common: require("../../public/locales/en/common.json"),
      itinerary: require("../../public/locales/en/itinerary.json"),
    },
    // Other languages can be loaded similarly if needed
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
